import { COLORS } from '@constants/colors';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    scrollable: {
      height: 545,
      maxHeight: 'calc(100vh - 376px)',

      [breakpoints.down(ScreenSizes.PcWide)]: {
        maxHeight: 'calc(100dvh - 376px)',
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: 'calc(100vh - 268px)',
        maxHeight: 'calc(100dvh - 226px)',
      },
    },
    search: {
      marginBottom: 1,
    },
    empty: {
      textAlign: 'center',
      color: COLORS.WHITE,
      pt: 1,
      fontSize: '14px',
    },
  };
};
